import { render } from "./account-settings-email.vue?vue&type=template&id=126de2e9&scoped=true&ts=true"
import script from "./account-settings-email.vue?vue&type=script&lang=ts"
export * from "./account-settings-email.vue?vue&type=script&lang=ts"

import "./account-settings-email.vue?vue&type=style&index=0&id=126de2e9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126de2e9"]])

export default __exports__